import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRightLong} from "@fortawesome/free-solid-svg-icons";
import {TmHeadTransitionDirection} from "../../js/entities/TuringMachine/TmTransitionRule";

/**
 * Displays {@link TmTransitionRule} as a row
 * @param transitionRule {TmTransitionRule}
 * @param isHighlighted {boolean} if returning row must be highlighted with other bg color
 * @constructor
 */
export default function TmTransitionRuleComponent({transitionRule, isHighlighted}) {
    return (
        <div className={(isHighlighted) ?
            'row m-0 pt-1 pb-1 height-limited-scroll-container-item container-highlighted transition-rule-highlighted' :
            'row m-0 pt-1 pb-1 height-limited-scroll-container-item'}>
            {/* transition-rule-highlighted clas is only for find selected transitionRules to focus on them */}

            <div className="col-2 p-1 single-line-ellipsis-text-container text-center">
                {transitionRule.fromState.name}
            </div>

            <div className="col-2 p-1 single-line-ellipsis-text-container text-center">
                {transitionRule.lookedChar}
            </div>

            <div className="col-2 p-1 single-line-ellipsis-text-container text-center">
                <FontAwesomeIcon icon={faArrowRightLong}/>
            </div>

            <div className="col-2 p-1 single-line-ellipsis-text-container text-center">
                {transitionRule.toState.name}
            </div>

            <div className="col-2 p-1 single-line-ellipsis-text-container text-center">
                {transitionRule.charToWrite}
            </div>

            <div className="col-2 p-1 single-line-ellipsis-text-container text-center">
                {TmHeadTransitionDirection.toShortString(transitionRule.headDirection)}
            </div>
        </div>
    );
}